import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { AppLayoutDahboardWithNav } from '@/modules/shared/layouts/AppLayoutDahboardWithNav'
import { toRelativeRoute, wrapRoutesWithRouter } from '@/modules/shared/utils/routerPaths'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'
import { billingRoutes } from './routes'
import { billingPath } from './index'
import { BillingLayout } from './BillingLayout'

const wrappedBillingRoutes = wrapRoutesWithRouter(billingRoutes)

const BillingModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <AppLayoutDahboardWithNav>
        <PermissionGuard companyId={companyId} {...moduleAccess.billing}>
          <BillingLayout companyId={companyId!}>
            <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
              <Routes>
                {wrappedBillingRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={`${toRelativeRoute(route.path, billingPath)}/*`}
                    element={<route.Component />}
                  />
                ))}
                <Route
                  path="*"
                  element={<div>Billing Module - Select a view</div>}
                />
              </Routes>
            </ErrorBoundary>
          </BillingLayout>
        </PermissionGuard>
      </AppLayoutDahboardWithNav>
    </ErrorBoundary>
  )
}

export const BillingModule = BillingModuleImpl
